import * as yup from "yup";
import { Countries } from "../../../../utilities/constants";

export const filterFormSchema = yup.object().shape({
  email: yup.string("The email is not valid."),
});

export const filterFormFields = () => [
  {
    stepNo: 1,
    title: "",
    fields: [
      {
        name: "firstName",
        fieldId: "firstName",
        label: "Name",
        placeholder: "Petar",
        type: "input-text",
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
      {
        name: "lastName",
        fieldId: "lastName",
        label: "Surname",
        placeholder: "Petrov",
        type: "input-text",
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
      {
        name: "email",
        fieldId: "email",
        label: "E-mail",
        placeholder: "petar@gmail.com",
        type: "input-text",
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "country",
        fieldId: "country",
        label: "Country",
        placeholder: "Macedonia",
        type: "select",
        values: [{ label: "Select a country", value: "", disabled: true }, ...Countries.map((i) => ({ label: i, value: i }))],
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "city",
        fieldId: "city",
        label: "City",
        placeholder: "Skopje",
        type: "input-text",
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
      {
        name: "isAccountVerified",
        fieldId: "isAccountVerified",
        label: "Account Verified",
        type: "checkbox",
        value: true,
        style: {
          padding: "30px 10px 0",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
      {
        name: "isEmailVerified",
        fieldId: "isEmailVerified",
        label: "Email Verified",
        type: "checkbox",
        value: true,
        style: {
          padding: "30px 10px 0",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
    ],
  },
];
